/**
 * Auto-draft PDF Work Specification frequencies from the DSNY schedule the user
 * entered, so the contract document reflects the actual schedule instead of
 * template defaults. Only rows we can map confidently are touched; everything
 * else keeps its template default and remains user-editable.
 */

import type { WorkSpecRow } from '../types/agreement'

export interface DsnyScheduleRowLite {
  type: string
  days: number[]
}

const daysPerWeek = (n: number) => `${n} day${n === 1 ? '' : 's'}/week`

export function draftDsnyWorkSpecFrequencies(
  workSpecs: WorkSpecRow[],
  rows: DsnyScheduleRowLite[]
): WorkSpecRow[] {
  const dayCount = (type: string) => rows.find((r) => r.type === type)?.days?.length ?? 0
  const garbage = dayCount('garbage')
  const recycling = dayCount('recycling')
  const hallway = dayCount('hallway_cleaning')

  let changed = false
  const next = workSpecs.map((spec) => {
    const task = (spec.task || '').toLowerCase()
    let frequency: string | null = null

    if (spec.group === 'Interior' && hallway > 0) {
      frequency = daysPerWeek(hallway)
    } else if (task.includes('trash can') && garbage > 0) {
      frequency = daysPerWeek(garbage)
    } else if ((task.includes('recyclable') || task.includes('boxes')) && recycling > 0) {
      frequency = daysPerWeek(recycling)
    }

    if (frequency && frequency !== spec.frequency) {
      changed = true
      return { ...spec, frequency }
    }
    return spec
  })

  return changed ? next : workSpecs
}
